import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import DailyReport from '@/components/DailyReport'
import WeeklyReport from '@/components/WeeklyReport'
import Compset from '@/components/Compset'

Vue.use(Router)

const router = new Router({
  routes: [
    { name: 'Welcome', path: '/', component: Welcome, meta: { title: 'Welcome' } },
    { name: 'Create', path: '/welcome/:action', component: Welcome, meta: { title: 'Welcome' }, props: true },
    // DailyReport & WeeklyReport  is needed for GENERATE  reports
    { name: 'DailyReport', path: '/DailyReport/:action', component: DailyReport, meta: { title: 'DailyReport' }, props: true },
    { name: 'WeeklyReport', path: '/WeeklyReport/:action', component: WeeklyReport, meta: { title: 'WeeklyReport' }, props: true },
    // Compset is needed to add Service category for tasks from create task. This is needed for the communities does not have helpdesk menus
    { name: 'Compset', path: '/Compset', component: Compset, meta: { title: 'Settings' }, props: true }
    // remaining routers are added dynamically in App.vue while creating menu
  ],
  mode: 'history'
})

// Menu-driven routes are code-split (see App.vue's `() => import(...)`), so a
// browser tab left open across a deployment still holds the old chunk-id ->
// filename map. Navigating to a not-yet-loaded chunk then requests a file the
// new deploy no longer has, the server's history-mode fallback returns
// index.html for it, and the script tag fails with a MIME-type error
// ("Loading chunk N failed."). Reload once to pick up the freshly deployed
// bundle instead of leaving the user stuck on a broken navigation.
const CHUNK_RELOAD_KEY = 'chunk-load-error-reloaded'

router.onError((error) => {
  const isChunkLoadError = /Loading( CSS)? chunk (\d)+ failed/.test(error.message) || error.name === 'ChunkLoadError'
  if (isChunkLoadError && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
    window.location.reload()
  }
})

// A route that resolves normally means the current bundle is good again
// (e.g. after the reload above), so allow future chunk failures to trigger
// another recovery reload instead of permanently suppressing it.
router.afterEach(() => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js